import React from 'react';

const FoodItem = ({ name, ingredients, price }) => {
  return (
    <div className="flex flex-col mb-8 group">
      <div className="flex items-end justify-between mb-1">
        <h3 className="text-xl lg:text-3xl font-bold text-amber-50 group-hover:text-amber-400 transition-colors">
          {name}
        </h3>
        <div className="menu-item-separator hidden md:block" />
        <span className="text-xl lg:text-3xl font-semibold text-amber-500 bg-amber-500/10 px-3 py-1 rounded-lg">
          {price}
        </span>
      </div>
      <p className="text-slate-400 text-sm lg:text-xl italic font-light tracking-wide lg:max-w-2xl">
        {ingredients}
      </p>
      <div className="h-px w-full bg-gradient-to-r from-slate-700/50 via-slate-700 to-slate-700/50 mt-6" />
    </div>
  );
};

export default FoodItem;